import { Component } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { AlarmSetupComponent } from '../../layout/components/alarm-setup/alarm-setup.component'
import { HeaderComponent } from '../../layout/components/header/header.component'

@Component({
  selector: 'app-wake-up-alarm',
  standalone: true,
  imports: [TranslateModule, AlarmSetupComponent, HeaderComponent],
  templateUrl: './wake-up-alarm.component.html',
  styleUrls: ['./wake-up-alarm.component.scss'],
})
export class WakeUpAlarmComponent {}
